<script setup lang="ts">

interface Props {
  pageUrl: String | string;
  src?: String | string | undefined;
  width?: Number | number | undefined;
  height?: Number | number | undefined;
  [x: string]: any;
};

const props = withDefaults(defineProps<Props>(), {
  src: 'https://www.facebook.com/plugins/page.php?href=[PAGE]&tabs=timeline&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true',
  width: 340,
  height: 500
});

const computedSrc = computed<String | string>((): String | string => {
  let url = props.src.replace('[PAGE]', encodeURIComponent(props.pageUrl));

  return `${url}&width=${props.width}&height=${props.height}`;
});

const emit = defineEmits(['click', 'focus']);
</script>

<template>
  <div
    class="block relative w-full h-full overflow-auto text-center"
    @click="(e: Event) => emit('click', e)"
    @focus="(e: Event) => emit('focus', e)">
    <iframe
      class="border-0 overflow-auto w-full h-full"
      :style="{
        minWidth: `${width}px`,
        minHeight: `${height}px`
      }"
      allowfullscreen
      scrolling="no"
      frameborder="0"
      loading="lazy"
      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
      :src="computedSrc">
    </iframe>
  </div>
</template>
